import type { UseFormUnregister } from "react-hook-form";
import { INPUT_FIELD_NAMES } from "constants/fieldNames.constans";
import type { FormFieldPath, FormValues } from "types/form.types";

export const TOOL_SECTION_KEYS: (keyof FormValues)[] = [
  "containerTracking",
  "airTracking",
  "vesselSchedules",
  "transitTime",
  "carbonEmissions",
  "cargoLoadOptimizer",
  "webAccess",
  "webIntegration",
  "api",
] as const;

/** All dynamic field paths — reset individually so shared names do not keep old values. */
export const DYNAMIC_FIELD_PATHS = [
  INPUT_FIELD_NAMES.containerTrackingrequest_types,
  // INPUT_FIELD_NAMES.containerTrackingContainersPerMonth,
  INPUT_FIELD_NAMES.containerTrackingmonthly_shipments,
  INPUT_FIELD_NAMES.containerTrackingSearchesPerMonth,
  INPUT_FIELD_NAMES.containerTrackingApiCallsPerMonth,
  INPUT_FIELD_NAMES.containerTrackingLicences,
  INPUT_FIELD_NAMES.airTrackingrequest_types,
  INPUT_FIELD_NAMES.airTrackingmonthly_shipments,
  INPUT_FIELD_NAMES.airTrackingSearchesPerMonth,
  INPUT_FIELD_NAMES.airTrackingApiCallsPerMonth,
  INPUT_FIELD_NAMES.airTrackingLicences,
  INPUT_FIELD_NAMES.vesselSchedulessearch_modes,
  INPUT_FIELD_NAMES.vesselSchedulesSearchesPerMonth,
  INPUT_FIELD_NAMES.vesselSchedulesLicences,
  INPUT_FIELD_NAMES.transitTimeTransportTypes,
  // INPUT_FIELD_NAMES.transitTimeCalculationsPerMonth,
  INPUT_FIELD_NAMES.transitTimeLicences,
  INPUT_FIELD_NAMES.carbonEmissionsShippingTypes,
  INPUT_FIELD_NAMES.carbonEmissionsTypeOfCalculation,
  INPUT_FIELD_NAMES.carbonEmissionsCalculationsPerMonth,
  INPUT_FIELD_NAMES.carbonEmissionsLicences,
  INPUT_FIELD_NAMES.cargoLoadOptimizerLicences,
  // INPUT_FIELD_NAMES.apiPerMonth,
  // INPUT_FIELD_NAMES.apiActions,
  INPUT_FIELD_NAMES.webAccessShipmentsPerMonth,
  INPUT_FIELD_NAMES.webAccessDevices,
  INPUT_FIELD_NAMES.webAccessLicences,
  INPUT_FIELD_NAMES.webIntegrationSearchesPerMonth,
  INPUT_FIELD_NAMES.webIntegrationSubAccounts,
  INPUT_FIELD_NAMES.webIntegrationPerDay,
  INPUT_FIELD_NAMES.webIntegrationDevices,
  INPUT_FIELD_NAMES.webIntegrationLicences,
] as const satisfies readonly FormFieldPath[];

export const resetAllDynamicFormFields = (unregister: UseFormUnregister<FormValues>) => {
  TOOL_SECTION_KEYS.forEach((section) => {
    unregister(section);
  });

  DYNAMIC_FIELD_PATHS.forEach((path) => {
    unregister(path);
  });
};
